"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaTitle = void 0;
const react_1 = __importDefault(require("react"));
const react_helmet_1 = require("react-helmet");
const MetaTitle = ({ children }) => {
    return (react_1.default.createElement(react_helmet_1.Helmet, { defaultTitle: "Hum Capital", titleTemplate: "%s \u2013 Hum Capital's Intelligent Capital Market" },
        react_1.default.createElement("title", null, children)));
};
exports.MetaTitle = MetaTitle;
//# sourceMappingURL=MetaTitle.js.map